export default __webpack_public_path__ + "static/media/ubicacion.725d2658.gif";